import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/20/solid';
import { useDocumentTitle } from '../../helpers/hooks';

export default function Page404() {
  useDocumentTitle('Page 404');

  return (
    <div className="bg-neutral-25 min-h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-main-600 sm:text-5xl">404</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-neutral-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-neutral-900 tracking-tight sm:text-5xl">Page not found</h1>
              <p className="mt-1 text-base text-neutral-500">Please check the URL in the address bar and try again.</p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white bg-main-600 hover:bg-main-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-main-500"
              >
                <HomeIcon className="w-4 h-4 mr-1" />
                {' '}
                Go back home
              </Link>
              {/* <a */}
              {/*  href="#" */}
              {/*  className="inline-flex items-center px-4 py-2 border
               border-transparent text-sm font-medium rounded-md text-main-700
               bg-main-100 hover:bg-main-200 focus:outline-none focus:ring-2
               focus:ring-offset-2 focus:ring-main-500" */}
              {/* > */}
              {/*  Contact support */}
              {/* </a> */}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
